/* tslint:disable */

/**
 */
export class OutputComputeTrTsParam {
    TR?: number[];
    TS?: number[];
    VC?: number[];
    TE?: number;
    doTr?: boolean;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/output-compute-tr-ts-param.ts